export default __webpack_public_path__ + "static/media/KOD0033-min.e30be310.webp";